import React, { FC } from 'react';
import { useCustomSettings } from '../../hooks/use-custom-settings';
import { OE_LOGO_IMG_PATH } from '../../lib/constants';

const PoweredBy: FC = () => {
  const {
    showWebsiteFooterLogoImage,
    websiteFooterLogoUrl,
    websiteFooterLogoTitle,
  } = useCustomSettings();

  if (websiteFooterLogoUrl || showWebsiteFooterLogoImage) return (
    <div className='powered-by px-4 text-center'>
      {showWebsiteFooterLogoImage ? <span className='powered-by-text' aria-hidden='true'>Powered By</span> : null}
      <img
        src={showWebsiteFooterLogoImage ? OE_LOGO_IMG_PATH : websiteFooterLogoUrl}
        alt={showWebsiteFooterLogoImage ? '' : websiteFooterLogoTitle}
        title={showWebsiteFooterLogoImage ? undefined : websiteFooterLogoTitle}
        aria-hidden={showWebsiteFooterLogoImage ? 'true' : undefined}
        className={`inline-block max-h-6 ${showWebsiteFooterLogoImage ? 'oe-footer-logo-image' : ''}`}
      />
    </div>
  );
  return null;

};

export default PoweredBy;
